module.exports = __webpack_public_path__ + "static/img/afinder-logo.bbe84e61.png";